export default {
	background: {
		forest: '/game-images/jumper/background/forest.jpg',
		graveyard: '/game-images/jumper/background/graveyard.jpg',
		house: '/game-images/jumper/background/house.jpg',
		factory: '/game-images/jumper/background/factory.jpg'
	},
	platform: {
		large: [
			'/game-images/jumper/platform/large-1.png',
			'/game-images/jumper/platform/large-2.png'
		],
		medium: '/game-images/jumper/platform/medium.png',
		small: '/game-images/jumper/platform/small.png'
	},
	bat: {
		flying: [
			'/game-images/jumper/bat/flying/1.png',
			'/game-images/jumper/bat/flying/2.png',
			'/game-images/jumper/bat/flying/3.png',
			'/game-images/jumper/bat/flying/4.png',
			'/game-images/jumper/bat/flying/5.png',
			'/game-images/jumper/bat/flying/6.png',
			'/game-images/jumper/bat/flying/7.png',
			'/game-images/jumper/bat/flying/8.png',
			'/game-images/jumper/bat/flying/9.png',
			'/game-images/jumper/bat/flying/10.png',
			'/game-images/jumper/bat/flying/11.png'
		],
		dead: '/game-images/jumper/bat/dead.png'
	},
	ghost: {
		flying: [
			'/game-images/jumper/ghost/flying/1.png',
			'/game-images/jumper/ghost/flying/2.png',
			'/game-images/jumper/ghost/flying/3.png',
			'/game-images/jumper/ghost/flying/4.png',
			'/game-images/jumper/ghost/flying/5.png',
			'/game-images/jumper/ghost/flying/6.png',
			'/game-images/jumper/ghost/flying/7.png',
			'/game-images/jumper/ghost/flying/8.png',
			'/game-images/jumper/ghost/flying/9.png',
			'/game-images/jumper/ghost/flying/10.png',
			'/game-images/jumper/ghost/flying/11.png'
		]
	},
	spider: {
		moving: [
			'/game-images/jumper/spider/moving/1.png',
			'/game-images/jumper/spider/moving/2.png'
		],
		idle: '/game-images/jumper/spider/idle.png',
		dead: '/game-images/jumper/spider/dead.png'
	},
	spiderNet: '/game-images/jumper/spider-net/spider-net.png',
	dummy: {
		green: {
			left: {
				running: [
					'/game-images/jumper/dummy/green/left/running/1.png',
					'/game-images/jumper/dummy/green/left/running/2.png',
					'/game-images/jumper/dummy/green/left/running/3.png',
					'/game-images/jumper/dummy/green/left/running/4.png'
				],
				jumping: [
					'/game-images/jumper/dummy/green/left/jumping/1.png',
					'/game-images/jumper/dummy/green/left/jumping/2.png'
				],
				idle: [
					'/game-images/jumper/dummy/green/left/idle/1.png',
					'/game-images/jumper/dummy/green/left/idle/2.png'
				],
				dead: [
					'/game-images/jumper/dummy/green/left/dead/1.png',
					'/game-images/jumper/dummy/green/left/dead/2.png'
				]
			},
			right: {
				running: [
					'/game-images/jumper/dummy/green/right/running/1.png',
					'/game-images/jumper/dummy/green/right/running/2.png',
					'/game-images/jumper/dummy/green/right/running/3.png',
					'/game-images/jumper/dummy/green/right/running/4.png'
				],
				jumping: [
					'/game-images/jumper/dummy/green/right/jumping/1.png',
					'/game-images/jumper/dummy/green/right/jumping/2.png'
				],
				idle: [
					'/game-images/jumper/dummy/green/right/idle/1.png',
					'/game-images/jumper/dummy/green/right/idle/2.png'
				],
				dead: [
					'/game-images/jumper/dummy/green/right/dead/1.png',
					'/game-images/jumper/dummy/green/right/dead/2.png'
				]
			}
		},
		yellow: {
			left: {
				running: [
					'/game-images/jumper/dummy/yellow/left/running/1.png',
					'/game-images/jumper/dummy/yellow/left/running/2.png',
					'/game-images/jumper/dummy/yellow/left/running/3.png',
					'/game-images/jumper/dummy/yellow/left/running/4.png',
					'/game-images/jumper/dummy/yellow/left/running/5.png'
				],
				jumping: [
					'/game-images/jumper/dummy/yellow/left/jumping/1.png',
					'/game-images/jumper/dummy/yellow/left/jumping/2.png'
				],
				idle: [
					'/game-images/jumper/dummy/yellow/left/idle/1.png',
					'/game-images/jumper/dummy/yellow/left/idle/2.png'
				],
				dead: [
					'/game-images/jumper/dummy/yellow/left/dead/1.png',
					'/game-images/jumper/dummy/yellow/left/dead/2.png'
				]
			},
			right: {
				running: [
					'/game-images/jumper/dummy/yellow/right/running/1.png',
					'/game-images/jumper/dummy/yellow/right/running/2.png',
					'/game-images/jumper/dummy/yellow/right/running/3.png',
					'/game-images/jumper/dummy/yellow/right/running/4.png',
					'/game-images/jumper/dummy/yellow/right/running/5.png'
				],
				jumping: [
					'/game-images/jumper/dummy/yellow/right/jumping/1.png',
					'/game-images/jumper/dummy/yellow/right/jumping/2.png'
				],
				idle: [
					'/game-images/jumper/dummy/yellow/right/idle/1.png',
					'/game-images/jumper/dummy/yellow/right/idle/2.png'
				],
				dead: [
					'/game-images/jumper/dummy/yellow/right/dead/1.png',
					'/game-images/jumper/dummy/yellow/right/dead/2.png'
				]
			}
		}
	}
};
